import Vue from "vue";
import App from "./App.vue";
import router from "./router";

import axios from "axios";
import VueAxios from "vue-axios";

import { msal, initMsal, getAccessToken, API_SCOPES } from "./services/auth.js";

import VueFormGenerator from "vue-form-generator";
import "vue-form-generator/dist/vfg.css";
import fieldCustompassword from "./components/atom/fieldCustompassword.vue";
Vue.component("FieldCustompassword", fieldCustompassword);

import Buefy from "buefy";
import "buefy/dist/buefy.css";

Vue.use(Buefy, {
  defaultIconPack: "fa",
  defaultToastDuration: 4000,
});

axios.defaults.baseURL = process.env.VUE_APP_APIURL
axios.interceptors.request.use(
  async (config) => {
    const token = await getAccessToken();
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
      config.headers["Accept"] = "application/json";
      config.headers["Content-Type"] = "application/json";
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axios.interceptors.response.use((response) => {
  return response;
}, async function (error){
  const originalRequest = error.config;

  if(error.response){
    var isAuthorisationError = error.response.status === 403 || error.response.status === 401;

    if (isAuthorisationError && !originalRequest._retry) {
        originalRequest._retry = true;

        const token = await getAccessToken();

        if (!token) {
          // No token could be acquired — likely redirected or not authenticated
          return Promise.reject(error);
        }

        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;

        if (originalRequest.data && typeof originalRequest.data === 'string')
            originalRequest.data = JSON.parse(originalRequest.data); //otherwise the content type is set as text not json on second attempt

        return axios(originalRequest);
    }
  }else if (error.request) {
        // The request was made but no response was received
    } else {
        // Something happened in setting up the request that triggered an Error
    }

  return Promise.reject(error);
})

Vue.use(VueAxios, axios);
Vue.use(VueFormGenerator);

import VCalendar from "v-calendar";
Vue.use(VCalendar);

Vue.config.productionTip = false;

require("./assets/main.scss");

// Route guard using MSAL account
router.beforeEach(async (to, from, next) => {
  const account = window.msal?.getActiveAccount?.() || msal.getActiveAccount?.();
  const username = (account && account.username) || "";
  const isAdmin =
    username.toLowerCase().includes("jellyfishconnect.com") ||
    username.toLowerCase().includes("jellyfish.com");

  const isPublic   = to.matched.some(r => r.meta?.public);
  const needsAuth  = to.matched.some(r => r.meta?.requiresAuth);
  const needsAdmin = to.matched.some(r => r.meta?.is_admin);

  // Logged-in user going to a public page send to Dashboard
  if (isPublic && account) {
    if (to.name !== "Dashboard") return next({ name: "Dashboard", replace: true });
    return next();
  }

  // Protected pages require auth
  if (needsAuth && !account) {
    await msal.loginRedirect({ scopes: API_SCOPES });
    return;
  }

  // Admin pages
  if (needsAdmin && !isAdmin) {
    alert("no permissions");
    return next({ name: "Login", replace: true });
  }

  next();
});


// Initialize MSAL
import { store } from "./store/store";
(async () => {
  await initMsal();
  window.msal = msal;

  window.App = new Vue({
    store,
    router,
    render: (h) => h(App),
  }).$mount("#app");
})();

document.addEventListener("DOMContentLoaded", () => {
  const $navbarBurgers = Array.prototype.slice.call(
    document.querySelectorAll(".navbar-burger"),
    0
  );

  if ($navbarBurgers.length > 0) {
    $navbarBurgers.forEach((el) => {
      el.addEventListener("click", () => {
        const target = el.dataset.target;
        const $target = document.getElementById(target);
        el.classList.toggle("is-active");
        $target.classList.toggle("is-active");
      });
    });
  }
});
